import moment from 'moment-timezone';

export default {
  props: {
    timezone: {
      default: 'America/Los_Angeles',
    },
  },

  computed: {
    timeZoneAbbr() {
      return moment.tz(this.timezone).format('z');
    },
  },
};
